import React from 'react';
import axios from "axios";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
 
const Otpverify = () => {
    const history = useHistory();
    const [verify, setVerify] = useState({
        email: '',
        otp: ''
    });
 
    const handleVerificationDetails = (e) => {
        setVerify({
            ...verify,
            [e.target.name]: e.target.value
        });
    };
 
    const handleOtpVerify = () => {
        axios
            .post(`${process.env.REACT_APP_BE_MAIN_URL}/user/verify/`, verify, {
                headers: {
                    Accept: 'application/json'
                }
            })
 
            .then((response) => {
                if (response.status === 200) {
                    alert("Verified successfully");
                    return history.push("/login");
                }
            })
            .catch((err) => {
                // console.log(err);
                alert("Incorrect data");
            })
    };
 
    useEffect(() => {
        sessionStorage.clear();
    }, []);
 
    return (
        <div className="flex justify-center items-center h-screen bg-gradient-to-r from-cyan-500 via-cyan-700 to-cyan-800">
            <div className=" p-6  rounded-md w-full sm:max-w-md">
                <h2 className="text-2xl font-bold  text-slate-100 flex items-centre mb-4">Email Verification</h2>
 
                <div className="mb-4">
                    <label className="block text-xl font-medium text-gray-100">E-Mail</label>
                    <input type="text" name="email" placeholder="Enter your mail" className="mt-1 p-2 w-full border rounded-md" onChange={(e) => handleVerificationDetails(e)} />
                </div>
                <div className="mb-6">
 
                    <label className="block text-xl font-medium text-gray-100">OTP</label>
                    <input type="" name="otp" placeholder="Enter OTP" className="mt-1 p-2 w-full border rounded-md" onChange={(e) => handleVerificationDetails(e)} />
                    <p className="text-gray-100 mb-6">Enter the OTP sent to your Email</p>
                </div>
                <button className="bg-sky-100 hover:bg-sky-500 text-black py-2 font-bold text-xl px-4 rounded-md w-full" onClick={() => handleOtpVerify()}>Verify</button>
                <p className="text-center text-gray-200 mt-4">Didn't receive the code? <a href="#" className="text-white">Resend</a></p>
            </div>
            <ToastContainer />
        </div>
    );
};
 
export default Otpverify;